import { createStorefrontApiClient } from '@shopify/storefront-api-client';

const STOREFRONT_API_VERSION = '2025-01';

/**
 * Creates a storefront API client.
 *
 * @param storefrontAccessToken - The storefront access token.
 * @param apiVersion - The API version.
 * @param storeDomain - The store domain.
 * @returns The storefront API client.
 */
export const createClient = (
  storefrontAccessToken: string,
  apiVersion: string,
  storeDomain?: string,
) => {
  if (
    !storefrontAccessToken ||
    (typeof window !== 'undefined' &&
      (window as any)?.CANDYRACK_SHOULD_DISABLE_STOREFRONT_API)
  ) {
    return null;
  }

  return createStorefrontApiClient({
    storeDomain:
      storeDomain ??
      (typeof window !== 'undefined'
        ? (window as any)?.Shopify?.shop
        : undefined),
    apiVersion: apiVersion,
    publicAccessToken: storefrontAccessToken,
  });
};

/**
 * Creates a storefront API client.
 *
 * @param storefrontAccessToken - The storefront access token.
 * @returns The storefront API client.
 */
const createApiClient = (storefrontAccessToken: string) => createClient(storefrontAccessToken, STOREFRONT_API_VERSION)

export default createApiClient;
